import PopupOpenConfigStorage from '../../constants/PopupOpenConfigStorage';
import { GameClient, GameClientLoadingState } from '../../gameClient/gameClient';
import { SetKeyboardEnabledCommand } from '../../gameClient/clientCommands/setKeyboardEnabledCommand';
import { CurrentPage } from '../../pages/currentPage';
import { PreloaderScreen } from '../../gameClient/webgl/preloaderScreen';
import { DownloadScreen } from '../../gameClient/webgl/downloadScreen';
import { PopupConfigData } from '../../constants/popup-config-data';
import { Url } from './url';
import { bindJsClick } from './jsClick';
import axios from 'axios';
import { LoadingAnimator } from '../../utils/loading/loadingAnimator';

setPopupClosed();

window.app.popup = openPopup;
window.app.closePopups = closePopups;
window.app.closeAndOpenPopup = closeAllPopupsAndOpen;
window.app.game_popup = hideClientAndShowPopup;
window.app.game_popup_close = hidePopupsAndShowClient;


/**
 * Открывает попап #id и выравнивает его по центру,
 * а также включает затемнение при наличии аттрибута blackout
 * @return {boolean}
 */
function openPopup(params: PopupConfigData): boolean {
    const id = params.id;
    const $popup = $(`#${id}`);
    if (!$popup.length && params.url) {
        lazyOpenPopup(params);
        return true;
    }

    initPopup($popup, params);

    $popup.show();
    bindsForPopup($popup, params);

    return false;
}

// eslint-disable-next-line complexity
function initPopup($popup: JQuery<HTMLElement>, params: PopupConfigData) {
    const hideClass = typeof params.hideclass === 'undefined' ? false : params.hideclass;
    const alignOff = typeof params.alignoff === 'undefined' ? false : params.alignoff;
    const autoPosOff = typeof params.autoposoff === 'undefined' ? false : params.autoposoff;

    if (CurrentPage.isGamePage()) {
        GameClient.clientApiReady().then(() => {
            if ($popup.is(':visible')) {
                GameClient
                    .getInstance()
                    .sendCommand(new SetKeyboardEnabledCommand({ enabled: 0 }));
            }
        });
    }

    if (hideClass) {
        $(`.${hideClass}`).hide();
    }

    if (!alignOff) {
        alignPopupCenter($popup);
        $(window).on('resize.popupAlign', () => {
            alignPopupCenter($popup);
        });
    }

    const $closeButton = $('.js-close-button', $popup);
    if (
        autoPosOff ||
        (typeof $closeButton !== 'undefined' && !$closeButton.data('autoposoff'))
    ) {
        if (!window.app.config.rtl_lang) {
            const popupWidth = $popup.width();
            const closeButtonWidth = $closeButton.width();
            if (popupWidth !== undefined && closeButtonWidth !== undefined) {
                $closeButton.css('margin-left', (popupWidth - closeButtonWidth));
            }
        }
    }

    if (parseInt($popup.data('blackout')) !== 0) {
        const bodyHeight = $('body').height();
        if (bodyHeight === undefined) {
            throw new Error('bodyHeight is undefined');
        }
        $('#blackout').css('height', bodyHeight)
            .show();
    }
}

function bindsForPopup($popup: JQuery<HTMLElement>, params: PopupConfigData) {
    const firstInputFocus = typeof params.firstInputFocus === 'undefined' ? true : params.firstInputFocus;

    if (firstInputFocus) {
        $popup.find('input:visible')
            .first()
            .trigger('focus');
    }
}


function closePopups(params: PopupConfigData) {
    if (typeof params !== 'undefined' && typeof params.hideclass !== 'undefined') {
        $(`.${params.hideclass}`).hide();
    } else {
        $('.popup,.popup-no-style').hide();
    }

    if (CurrentPage.isGamePage()) {
        GameClient.clientApiReady().then(() => {
            if ($('.popup,.popup-no-style').is(':visible')) {
                return;
            }

            GameClient
                .getInstance()
                .sendCommand(new SetKeyboardEnabledCommand({ enabled: 1 }));

            window.app.game_popup_close();
        });
    }

    $(window).off('resize.popupAlign');
}


function closeAllPopupsAndOpen(params: PopupConfigData) {
    window.app.closePopups(params);
    disableResizePopupCentering();
    window.app.popup(params);
}

function setPopupOpened() {
    window.app.popup_opened = true;
}

function setPopupClosed() {
    window.app.popup_opened = false;
}

export function hideClientAndShowPopup(id: string) {
    const popupOpenConfig = PopupOpenConfigStorage.getPopupOpenConfig(id);

    setPopupOpened();

    $('#download_client_screen').hide();
    $('#game_frame').addClass('bg_pattern');

    if (CurrentPage.isGamePage()) {
        if (GameClient.getInstance().getLoadingState() === GameClientLoadingState.LOADED) {
            PreloaderScreen.getInstance().hide();
            GameClient.hide();
        } else {
            PreloaderScreen.getInstance().hide();
        }
    }

    window.app.popup(popupOpenConfig);
}

/**
 * закрывает все попап окна, показывает окно провала вставки (если флеш не вставился),
 * показывает флешку
 */

export function hidePopupsAndShowClient() {
    setPopupClosed();

    if (CurrentPage.isGamePage()) {
        GameClient.clientApiReady().then(() => {
            if (!($('.popup,.popup-no-style').is(':visible'))) {
                GameClient
                    .getInstance()
                    .sendCommand(new SetKeyboardEnabledCommand({ enabled: 1 }));
            }
        });
    }

    if (!window.app.isDesktop) {
        DownloadScreen.show();
        return;
    }

    $('.popup,.popup-no-style').hide();
    $('#support_success').hide();
    $('#game_frame').removeClass('bg_pattern');


    if (GameClient.getInstance().getLoadingState() === GameClientLoadingState.LOADED) {
        GameClient.show();
    } else {
        PreloaderScreen.getInstance().show();
    }
}

function alignPopupCenter($popup: JQuery) {
    const magicNumber = 42;
    const popupHeight = $popup.outerHeight();
    const popupWidth = $popup.outerWidth();
    if (popupHeight === undefined || popupWidth === undefined) {
        throw new Error('popupHeight or popupWidth is undefined');
    }
    const marginTop = ((window.innerHeight - popupHeight) / 2) + magicNumber;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fixSpaceBetweenTrElements = parseInt(marginTop as any as string, 10);
    $popup.css('margin-top', `${fixSpaceBetweenTrElements}px`);
    $popup.css('margin-left', `-${(popupWidth / 2)}px`);
}

function disableResizePopupCentering() {
    $(window).off('resize.popupAlign');
}

function lazyOpenPopup(params: PopupConfigData) {
    const loadingAnimator = new LoadingAnimator($('body'));
    loadingAnimator.startLoading();

    (async() => {
        if (params.url === undefined) {
            throw new Error('params.url is undefined');
        }
        const view = await axios.get(Url.getFullLangUrl(params.url));
        $('body').append(view.data);
        const $popup = $(`#${params.id}`);
        bindForLoadedPopup($popup, params);

        loadingAnimator.stopLoading();
        openPopup(params);
    })();
}

function bindForLoadedPopup($popup: JQuery<HTMLElement>, params: PopupConfigData) {
    $popup.on('click', '.js-click, .js-click-no-block', bindJsClick);
    $popup.on('click', '.js-close-button', () => {
        closePopups(params);
    });
    $popup.find('.scrollbar-rail').scrollbar();
}
